<template lang="pug">
  div.ui-menu
    template(v-for="item in filteredMenu")
      slot(v-bind="item")
        router-link(:to="item.route" :class="item.attr.class")
          b-icon(v-if="item.icon" :icon="item.icon")
          span.menubar-label {{ item.label }}
          b-tag.is-danger.is-rounded(v-if="item.attr.badge") {{ item.attr.badge }}
</template>

<script>
import { mapGetters } from 'vuex';
import { routeTabMenu } from '../utils/nav';
export default {
  name: 'ui-menu',

  props: {
    menu: Array,
  },

  computed: {
    ...mapGetters(['user']),

    filteredMenu() {
      return routeTabMenu(this.menu);
    },
  },
};
</script>
